import React, { useState, useEffect, useRef } from "react";
import { useMediaQuery } from "react-responsive";
import "./styles.scss";
import { Modal } from "react-bootstrap";
import HvButton from "../../App/shared/HvButton";
import { CopyToClipboard } from "react-copy-to-clipboard";
import RollOver from "../../RollOver";

export default function SharingModal({ children, object }) {
  const isMobileDevice = useMediaQuery({
    query: "(max-width: 768px)",
  });
  const hocWrapper = useRef(null);
  const [show, setShow] = useState(false);
  const [tooltip, setTooltip] = useState("copy to clipboard");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleClick = e =>
    hocWrapper.current && hocWrapper.current.contains(e.target) && handleShow();
  useEffect(() => {
    document.body.addEventListener("click", handleClick);
    return () => {
      document.body.removeEventListener("click", handleClick);
    };
  }, []);
  
  return (
    <>
      <div ref={hocWrapper} className={`hor_click ${(window.location.pathname.indexOf("sound_track") > 0 || window.location.pathname.indexOf("post") > 0 )? 'hor_click-ml' : null }`}>
        {children}
      </div>
      <Modal id="embed-modal" show={show} onHide={handleClose}>
        <Modal.Body className="content">
          <p className="title">
            EMBEDDING{" "}
            <span className="font-weight-bold text-uppercase">
              {object.title}
            </span>
          </p>
          <div
            className="embed-link-preview mt-3"
            dangerouslySetInnerHTML={{ __html: object.embed_snippet }}
          />

          <p className="hint py-3">
            YOU CAN ADD THIS PLAYER TO A WEBSITE BY COPYING THE HTML CODE BELOW:
          </p>
          <RollOver text={tooltip} className="tooltip-for-embed-modal">
            <CopyToClipboard
              text={object.embed_snippet}
              onCopy={() => setTooltip("Copied!")}
            >
              <div className="copy-section">{object.embed_snippet}</div>
            </CopyToClipboard>
          </RollOver>

          <HvButton
            type="button"
            className="btn btn-outline-primary close-button"
            onClick={handleClose}
          >
            close
          </HvButton>
        </Modal.Body>
      </Modal>
    </>
  );
}
